import styled from 'styled-components'

import { DropdownButton } from 'components/Button/StyledButton'

const CELL_VERITCAL_PADDING = '7px'
const CELL_HORIZONTAL_PADDING = '10px'

export default styled.div.withConfig({ shouldForwardProp: prop => prop === 'children' })(({ theme, withSearch, hideSearch, onRowClick }) => `
	.dx-widget, .dx-toolbar {
		font-family: inherit;
		color: inherit;
		input {
			font-family: inherit;
			line-height: inherit;
		}
	}
	.dx-toolbar {
		background: transparent;
	}
	.dx-datagrid {
		background: transparent;

		&-header-panel {
			visibility: ${(withSearch && hideSearch) ? 'hidden' : 'visible'};
		}

		&-headers {
			border-bottom: none;
			& + .dx-datagrid-rowsview {
				border-top: none;
			}
			.dx-datagrid-content {
				margin-bottom: 0;
			}
		}

		&-content {
			.dx-datagrid-table .dx-row {
				cursor: ${onRowClick ? 'pointer' : 'auto'};
				border: none;
				&.row-warning {
  					background: #ffe0d9;
  				}
				& > td {
					height: 36px;
					vertical-align: middle;
					padding: ${CELL_VERITCAL_PADDING} ${CELL_HORIZONTAL_PADDING};
					position: relative;
					font-size: 14px;
					font-weight: 300;
					background: transparent;
					color: ${theme?.primaryColor};
					border: none;
					&:not(:first-of-type):after {
						content: '';
						position: absolute;
						top: 8px;
						bottom: 8px;
						left: 0;
						width: 1px;
						background: rgba(195, 195, 195, 0.42);
					}
					&.dx-datagrid-group-space {
						&:after, & + td:after {
							display: none;
						}
					}
				}
				&.dx-header-row {
					& > td {
						color: #fff;
						font-size: 12px;
						&:after {
							background: rgba(47, 54, 72, 0.8);
						}
						&[aria-sort="ascending"] {
							box-shadow: inset 0 2px 0 0 ${theme?.activeColor};
						}
						&[aria-sort="descending"] {
							box-shadow: inset 0 -2px 0 0 ${theme?.activeColor};
						}
					}
				}
				&.dx-freespace-row, &.dx-group-row {
					& > td:after {
						display: none;
					}
				}
			}
			.dx-datagrid-table .dx-data-row .disabled {
				opacity: 0.5;
			}
		}

		&-rowsview {
			box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.2);
			.dx-texteditor-input {
				padding-left: 0px;
				min-height: auto;
			}
		}

		&-rowsview .dx-datagrid-content {
			box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.2);
			.dx-row {
				&:nth-child(even) {
					background: #fff !important;
				}
				&:not(.dx-freespace-row) {
					& > td:first-child {
						${onRowClick ? `padding-left: 18px;` : ''}
						&:before {
							content: "";
							position: absolute;
							top: 0;
							left: 0;
							height: calc(100% - 1px);
							width: 8px;
							background: #cdcdcd;
							z-index: 10;
							display: ${onRowClick ? 'block' : 'none'};
						}
					}
					&.dx-row-focused > td:first-child:before {
						background: ${theme?.primaryColor};
					}
				}
			}
			.dx-data-row .dx-cell-modified:after {}
		}

		.dx-datagrid-headers .dx-header-row > td {
			background: ${theme?.primaryColor};
		}

		&-total-footer {
			border-top: none;
			box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.2);
			& > .dx-datagrid-content {
				padding-top: 0;
				padding-bottom: 0;
				.dx-row > td {
					color: #fff;
					background: #3cb950;
				}
			}
			.dx-datagrid-summary-item {
				color: #fff;
				font-weight: 300;
			}
		}

		&-group-panel {
			border: 1px dashed #000;
			padding: 4px;
			.dx-group-panel-item, .dx-group-panel-message, .dx-block-separator {
				padding: 3px;
			}
		}

		.dx-column-indicators {
			display: none;
		}

	}

	.dx-cell-modified:after, .dx-highlight-outline:after, .dx-treelist-invalid:after {
		border: none !important;
	}
	.dx-datagrid-invalid {
		box-shadow: inset 0px 0px 3px 2px ${theme.errorColor};
	}
	.dx-editor-cell {
		.dx-texteditor, .dx-texteditor .dx-texteditor-input {
			background: transparent;			
		}
		div[class*=Select] {
			margin-bottom: 0;
		}
	}

	${DropdownButton} {
		background-color: #fff;
	}

	.dx-checkbox {
		&-checked .dx-checkbox-icon {
			border-color: ${theme?.primaryColor};
		}
		&-icon {
			color: ${theme?.primaryColor};
		}
	}
`)

export const CellWarning = styled.div`
	background: ${({ theme }) => theme.errorColor};
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: ${CELL_VERITCAL_PADDING} ${CELL_HORIZONTAL_PADDING};
	overflow: hidden;
	text-overflow: ellipsis;
`
